import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { filter, finalize, map, tap } from 'rxjs/operators';
import { SpeechEngine } from '@app/event/speech-engines/AbstractSpeechEngine';

@Injectable({
  providedIn: 'root'
})
export class WebkitService implements SpeechEngine {
  private supported = true;
  public language: string = 'en-US';
  private recognition: SpeechRecognition;
  private results$;
  private finalTranscription = '';
  private finalResults = [];
  private cursor = 0; // Cursor for interim results
  private buffer = 2;
  private interimWords: string[] = [];
  private isListening: boolean;

  constructor() {

    if (!this.newRecognition()) {
      return;
    }

    this.results$ = new Subject().pipe(
      map((e: SpeechRecognitionEvent) => {
        const i = e.resultIndex;
        const result = e.results[i];

        const text = result[0].transcript;

        const words = text.split(' ').filter(word => word !== '');

        const bufferLengthInWords = result.isFinal ? 0 : this.buffer;

        const startIndex = this.cursor;
        const endIndex = Math.max(words.length - bufferLengthInWords, 0);
        const interimWords = words.slice(startIndex, endIndex);
        this.cursor = endIndex;

        if (
          result.isFinal &&
          !this.finalResults.find(result => result === text)
        ) {
          this.cursor = 0;
        }

        return interimWords;
      }),
      filter(words => this.interimWords.join(' ') !== words.join(' ')),
      filter(words => !!words.length),
      tap(words => {
        this.interimWords = words;
      }),
      map(words => {
        return words.map(word => {
          return {
            word: word,
            startTime: new Date().toISOString()
          };
        });
      }),
      finalize(() => {
        this.isListening = false;
        this.recognition.stop();

      })
    );

  }

  newRecognition() {
    // @ts-ignore
    if (window['SpeechRecognition']) {
      this.recognition = new SpeechRecognition();
    } else if (window['webkitSpeechRecognition']) {
      // @ts-ignore
      this.recognition = new webkitSpeechRecognition();
    } else if (window['msSpeechRecognition']) {
      // @ts-ignore
      this.recognition = new msSpeechRecognition();
    } else {
      this.supported = false;
    }

    if (!this.supported) {
      return false;
    }

    this.recognition.interimResults = true;
    this.recognition.continuous = true;
    this.recognition.lang = this.language;
    console.log(this.recognition.lang);

    this.recognition.onresult = (e: SpeechRecognitionEvent) => {
      this.results$.next(e);
    };


    this.recognition.onspeechend = () => {

      this.newRecognition();
      this.recognition.start();
    };


    return true;
  }

  startListening$(language: string) {
   this.newRecognition();
    this.language = language;
    this.recognition.lang = language || 'en';
    this.recognition.start();
    this.isListening = true;
    return this.results$;
  }
}
